import {canSeeMargin} from '../custom-access/can'
import {cadCost, cadTerm} from './cad-cost'

// per-PO margin, ported from the old CADs page setMargins(). cost and term come
// from cadCost/cadTerm, so margin always agrees with the footer's Cost/Wholesale.
const showOrderMargin = (showFields) => {
  return canSeeMargin() && showFields != null && showFields.includes('Margin')
}

const orderMarginPercent = (price, cad, atsRepData) => {
  if (cad == null) return null
  // no term means we can't tell FOB (1.25x cost uplift) from LDP/DDP, so the
  // margin would be a guess -- hide it rather than show an overstated number.
  let term = cadTerm(cad, atsRepData)
  if (term == null || term === '') return null
  let cost = cadCost(cad, atsRepData)
  if (cost == null) return null
  price = Number(price)
  if (!price) return null
  let margin = term === 'FOB' ? (price - cost * 1.25) / price : (price - cost) / price
  return Math.round(margin * 100)
}

export {showOrderMargin, orderMarginPercent}
